var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Component, Prop, State, CustomElement, Event, Watch, html, classMap, nothing } from '@sick-davinci/ce-decorators';
import { style } from './TextArea.style';
export
/**
 * A `davinci-text-area` can be used to enter or edit multi-line-text.
 * It is taller than a `davinci-text-field` to indicate, that more than one line of text can be entered.
 * It does not support different input types like email or password, etc.
 *
 * @example
 * ```html
 * <davinci-text-area multiline label="Description" value="foo bar">
 * </davinci-text-area>
 * ```
 */
let TextArea = (_dec = Component({
  style: [style],
  tag: 'davinci-text-area'
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", Boolean), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", Boolean), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", Boolean), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", Boolean), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", Boolean), _dec18 = Prop(), _dec19 = Reflect.metadata("design:type", Boolean), _dec20 = Prop({
  reflectAsAttribute: false
}), _dec21 = Reflect.metadata("design:type", String), _dec22 = State(), _dec23 = Reflect.metadata("design:type", Boolean), _dec24 = State(), _dec25 = Reflect.metadata("design:type", Boolean), _dec26 = State(), _dec27 = Reflect.metadata("design:type", Boolean), _dec28 = Event(), _dec29 = Reflect.metadata("design:type", Object), _dec30 = Event(), _dec31 = Reflect.metadata("design:type", Object), _dec32 = Watch('value'), _dec33 = Reflect.metadata("design:paramtypes", [String, String]), _dec(_class = (_class2 = class TextArea extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "label", _descriptor, this);

    _initializerDefineProperty(this, "placeholder", _descriptor2, this);

    _initializerDefineProperty(this, "name", _descriptor3, this);

    _initializerDefineProperty(this, "required", _descriptor4, this);

    _initializerDefineProperty(this, "disabled", _descriptor5, this);

    _initializerDefineProperty(this, "readonly", _descriptor6, this);

    _initializerDefineProperty(this, "multiline", _descriptor7, this);

    _initializerDefineProperty(this, "error", _descriptor8, this);

    _initializerDefineProperty(this, "warning", _descriptor9, this);

    _initializerDefineProperty(this, "valueIsBlank", _descriptor10, this);

    _initializerDefineProperty(this, "showPlaceholder", _descriptor11, this);

    _initializerDefineProperty(this, "hasFocus", _descriptor12, this);

    _initializerDefineProperty(this, "change", _descriptor13, this);

    _initializerDefineProperty(this, "input", _descriptor14, this);

    this._internalValue = '';
    this._oldValue = '';

    this.onFocus = () => {
      this.hasFocus = true;
      this._oldValue = this._internalValue;
    };

    this.onBlur = () => {
      this._valueChangedByUser();

      this.hasFocus = false;
    };

    this.onInput = event => {
      event.preventDefault();
      event.stopPropagation();
      this._internalValue = event.target.value;
      this.showPlaceholder = !this._internalValue;
      this.input.emit(this.value);
    };

    this._valueChangedByUser = event => {
      if (event) {
        event.stopPropagation();
        event.preventDefault(); // in shadyDOM case the events might bubble, we have to prevent that
      }

      if (this._oldValue !== this._internalValue) {
        this.change.emit(this.value);
        this._oldValue = this._internalValue;
      }
    };
  }

  /**
   * Actual content of the text area.
   */
  set value(value) {
    this._internalValue = value || '';
  }

  get value() {
    return this._internalValue;
  }

  get isEditable() {
    return this.disabled || this.readonly;
  }

  valueChanged(_, newVal) {
    this.valueIsBlank = !newVal;
  }

  render() {
    return html`
      <div
        class=${classMap({
      container: true,
      valueIsBlank: !this._internalValue,
      hasPlaceholder: !!this.placeholder,
      showPlaceholder: this.showPlaceholder && !this._internalValue,
      focus: this.hasFocus
    })}
      >
        <textarea
          class="editable"
          @change=${this._valueChangedByUser}
          @input=${this.onInput}
          @focus=${this.onFocus}
          @blur=${this.onBlur}
          .value="${this.value}"
          ?disabled="${this.disabled}"
          ?readonly="${this.readonly}"
          ?error="${this.error}"
          ?warning="${this.warning}"
        ></textarea>
        ${this.label ? this._renderLabel() : ''}
        ${this.placeholder && !this.value ? this._renderPlaceholder() : ''}
      </div>
    `;
  }

  handleTouchAndDrag(event) {
    const {
      top,
      left
    } = this.getBoundingClientRect();

    switch (event.type) {
      case 'move':
        this.style.width = Math.max(event.clientX - left, 100) + 'px';

        if (!this.multiline) {
          this.style.height = Math.max(event.clientY - top, 50) + 'px';
        } else {
          this.style.height = '';
        }

        break;

      case 'cancel':
      case 'end':
        this.style.width = Math.max(event.clientX - left, 100) + 'px';

        if (!this.multiline) {
          this.style.height = Math.max(event.clientY - top, 50) + 'px';
        } else {
          this.style.height = '';
        }

        break;

      default:
        break;
    }
  }

  _renderLabel() {
    return html`
      <div class="label">${this.label}${this.required ? html` *` : nothing}</div>
    `;
  }

  _renderPlaceholder() {
    return html`
      <div class="placeholder">${this.placeholder}</div>
    `;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "placeholder", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "required", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "readonly", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "multiline", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "error", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "warning", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "value", [_dec20, _dec21], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "valueIsBlank", [_dec22, _dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "showPlaceholder", [_dec24, _dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "hasFocus", [_dec26, _dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec28, _dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec30, _dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "valueChanged", [_dec32, _dec33], Object.getOwnPropertyDescriptor(_class2.prototype, "valueChanged"), _class2.prototype)), _class2)) || _class);
